import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

/**
 * LegalPage — shell reutilizable para Aviso de Privacidad y Términos.
 * Hijos reciben un layout consistente: navbar, hero compacto, contenido y footer.
 */
export default function LegalPage({ eyebrow, title, lastUpdate, children, activeSlug }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page-wrapper">
      <Navbar />
      <main className="main-wrapper legal-wrapper" data-testid="legal-page">
        <section className="legal-hero">
          <div className="page-padding">
            <div className="container-large">
              <div className="text-label legal-eyebrow">{eyebrow}</div>
              <h1 className="sm-h1 legal-title">{title}</h1>
              {lastUpdate && (
                <p className="legal-last-update">Última actualización: {lastUpdate}</p>
              )}
              <nav className="legal-subnav" aria-label="Documentos legales">
                <Link
                  to="/aviso-privacidad"
                  className={`legal-subnav-link${activeSlug === 'aviso' ? ' active' : ''}`}
                  data-testid="legal-link-aviso"
                >
                  Aviso de privacidad
                </Link>
                <Link
                  to="/terminos"
                  className={`legal-subnav-link${activeSlug === 'terminos' ? ' active' : ''}`}
                  data-testid="legal-link-terminos"
                >
                  Términos y condiciones
                </Link>
              </nav>
            </div>
          </div>
        </section>

        <section className="legal-body">
          <div className="page-padding">
            <div className="container-medium">
              <article className="legal-article">{children}</article>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
